import React from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedValue } from '../../../../../store/reducers/campaign';
import TWV from '../../TextWithValue';

const TextWithValue = ({
  conditionId,
  label,
  value,
  textBefore,
  textAfter,
  max = null,
}) => {
  const dispatch = useDispatch();

  const handleChange = (newValue) => {
    const nNewValue = Number(newValue);
    if (nNewValue >= 0 && (!max || nNewValue <= max)) {
      dispatch(setSelectedValue({ conditionId, label, value: nNewValue }));
    }
  };

  return (
    <TWV
      conditionId={conditionId}
      label={label}
      value={value}
      textBefore={textBefore}
      textAfter={textAfter}
      onChange={handleChange}
    />
  );
};

export default TextWithValue;
